import $ from 'jquery';

export function smartPanel() {
    let currentScrollPosition = 0;
    const smartPanel = $('.smart-panel');
    
    const smartContent = $('.smart-panel__content');

    $(window).scroll(function () {
        let newScrollPosition = $(this).scrollTop();

        let bitrixWidget = null;
        if($('.b24-widget-button-wrapper').length != 0)
        {
            bitrixWidget = $('.b24-widget-button-wrapper');
        }

        if (newScrollPosition > currentScrollPosition) {
            smartPanel.removeClass('active');
            smartPanel.removeClass('open-content');
            smartContent.removeClass('open');

            if(bitrixWidget != null && smartPanel.length != 0)
            {
                bitrixWidget.addClass("b24-widget-button-visible");
            }
            
        } else {
            smartPanel.addClass('active');
            
            if(bitrixWidget != null && smartPanel.length != 0)
            {
                bitrixWidget.removeClass("b24-widget-button-visible");
            }           
        }
        currentScrollPosition = newScrollPosition;
    });
}


// WEBPACK FOOTER //
// app/scripts/components/smart-panel.js